import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { style: {"color":"#999"} }, [
  /*#__PURE__*/_createTextVNode("Uppss... La página no existe o se ha eliminado."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ¯\\_(ツ)_/¯")
], -1)

import DefaultLayout from '@/layouts/DefaultLayout.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NotFoundView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}
}

})